import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IBuyerUserPasswordClient,
    IPostInput,
    IPostOutput,
} from 'interfaceAdapter/gatewaySchemas/IBuyerUserPasswordClient';

const PATH = `${API_LOCATION_URL}/buyer/user/reset_password`;

export class BuyerUserPasswordClient implements IBuyerUserPasswordClient {
    async post(input: IPostInput): Promise<IPostOutput> {
        const { code, password } = input;
        const method = 'POST';
        const headers = {
            'Content-Type': 'application/json',
        };
        const body = JSON.stringify({ code, password });
        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });
            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
